import React from 'react'

import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import HFOptionGroup from 'components/HFInputs/HFOptionGroup'
import styles from '../Dialog.module.sass'
import { mapNonSurgicalAdmissionDetails } from 'controllers/TaskManager/TaskSubControllers/TaskDetailsControllers/detailsUtils'
import InfoList from 'components/InfoList/InfoList'
import TaskMedicalActsController from 'controllers/TaskManager/TaskSubControllers/TaskMedicalActsController/TaskMedicalActsController'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import HFTextInput from 'components/HFInputs/HFTextInput'
import { TaskNeedsController } from 'controllers/TaskManager/TaskSubControllers/TaskNeedsController/TaskNeedsController'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

export const NonSurgicalAdmissionForm = (props) => {
	const { i18n } = useGlobal()
	const { data } = props
	const { requisition, isFromIsland } = data

	/*const urgencyOptions = [
		{
			value: '1',
			text: i18n`Normal`,
			description: i18n`Surgery can wait`,
		},
		{
			value: '2',
			text: i18n`Urgent`,
			description: i18n`Surgery soon`,
		},
		{
			value: '3',
			text: i18n`Emergent`,
			description: i18n`Immediate surgery`,
		},
	]*/

	const requisitionDetails = mapNonSurgicalAdmissionDetails(requisition, i18n)

	return (
		<>
			<fieldset>
				<TaskMedicalActsController requisition={requisition} />
			</fieldset>

			{/* <fieldset>
				<h4>{i18n`Urgency`}</h4>
				<HFOptionGroup
					className={styles['option-group']}
					name='urgency'
					layout='horizontal'
					options={urgencyOptions}
				/>
			</fieldset>*/}

			<fieldset>
				<VStack>
					<h4>{i18n`Non surgical admission data`}</h4>
					<InfoList
						items={requisitionDetails}
						orientation={'vertical'}
					/>
				</VStack>
			</fieldset>

			{isFromIsland && (
				<TaskNeedsController
					isAdministrative={false}
					requisition={requisition}
				/>
			)}

			<fieldset className={styles['observation-container']}>
				<ExpandableWidget
					className={styles['observation']}
					heading='h5'
					title={i18n`Clinical Observation`}
				>
					<HFTextInput
						name='medicalObservation'
						placeholder={i18n`Clinical observation (optional)`}
						multiline={true}
						rows={5}
						noResize
					/>
				</ExpandableWidget>
			</fieldset>
		</>
	)
}
